<template>
  <div class="selecionar-relatorio">
    <div class="titulo-relatorio negrito fonte-secundaria">
      SELECIONE UM RELATÓRIO
    </div>
    <div class="segunda-cor-fonte" style="padding: 16px 0 40px 0">
      Selecione abaixo o tipo de relatório desejado
    </div>
    <div>
      <autocomplete
        style="width: 360px"
        mostrarIconeExcluir
        colorPlaceholder="#9E9E9E"
        placeholder="Relatórios"
        v-model="relatorio.descricao"
        @index="selecionarRelatorio"
        :items="
          listaRelatorios.map(e => {
            return { descricao: e.descricao, mensagem: e.mensagem };
          })
        "
      />
    </div>
  </div>
</template>

<script>
import Autocomplete from "@/shared/components/CustomAutocomplete/Autocomplete.vue";
export default {
  components: {
    Autocomplete
  },
  props: {
    listaRelatorios: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      relatorio: {
        chave: "",
        descricao: ""
      }
    };
  },
  methods: {
    selecionarRelatorio(index) {
      if ([null, undefined, -1].includes(index)) return;

      let chaveRelatorio = this.listaRelatorios[index].chave;
      this.relatorio.chave = chaveRelatorio;
      this.$emit("relatorio-selecionado", chaveRelatorio);
    }
  }
};
</script>

<style lang="scss" scoped>
.selecionar-relatorio {
  min-height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: wrap column;

  .titulo-relatorio {
    font-size: 26px;
  }
}
</style>
